import React from 'react';

const NotFound = () => {
    return (
        <div>
            <img className='w-full' src="https://i.stack.imgur.com/6M513.png" alt="" />
        </div>
    );
};

export default NotFound;